<template>
    <div>
        <div class="row">
            <div class="offset-xl-1 col-12">
               <div id="textoServico"><h1 class="textoNossosServicos  ml-4">Nossos Serviços</h1></div>
           </div>
        </div>
        <div class="row ml-4">
            <div class="col-11 text-center">
                <div class="row">

                    <div class="col-12">
                        <div class="imgNossoServicos">
                             <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">
                                <img src="~@/assets/imgs/nossos_servicos/consulta-gratuita.svg"            class="w-50" />
                            </a>
                        </div>
                    </div>
                    <div class="tituloCardServicos col-12 mt-4">
                         <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">Consulta gratuita</a>
                    </div>
                    <div class="col-12">
                        <div class="textoCardServicos mt-4">
                             <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">
                                 Saiba se existe algum protesto registrado em desfavor de pessoa jurídica ou física
                            </a>
                        </div>
                    </div>

                    <div class="col-11 ml-4">
                        <div class="imgNossoServicos">
                            <a href="../pdf/manualCertidao.pdf" target="_blank" style="color: inherit;">
                                <img src="~@/assets/imgs/nossos_servicos/certidao-protesto.svg"            class="w-50" />
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="tituloCardServicos mt-4">
                            <a href="../pdf/manualCertidao.pdf" target="_blank" style="color: inherit;">Certidão de protesto</a>
                        </div>
                    </div>
                    <div class="col-12 ">
                        <div class="textoCardServicos mt-4">
                            <a href="../pdf/manualCertidao.pdf" target="_blank" style="color: inherit;">
                                A certidão de protesto digital comprova se há protesto em desfavor do CPF ou CNPJ consultado, bem como todas as suas informações
                            </a>
                        </div>
                    </div>

                    <div class="col-11 ml-4">
                        <div class="imgNossoServicos">
                            <a href="../pdf/manualCancelamento.pdf" target="_blank" style="color: inherit;">
                                <img src="~@/assets/imgs/nossos_servicos/cancelamento-eletronico.svg"      class="w-50" />
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                         <div class="tituloCardServicos mt-4">
                             <a href="../pdf/manualCancelamento.pdf" target="_blank" style="color: inherit;">
                             Cancelamento eletrônico
                             </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="textoCardServicos mt-4">
                            <a href="../pdf/manualCancelamento.pdf" target="_blank" style="color: inherit;">
                                O credor pode emitir carta de anuência eletrônica para permitir que o devedor ou interessado possa pedir o cancelamento do protesto
                            </a>
                            </div>
                    </div>
                    <div class="col-12">
                        <div class="imgNossoServicos">
                            <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">
                                 <img src="~@/assets/imgs/Exclamacao.png"    width="40%"/>
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                         <div class="tituloCardServicos mt-4">
                              <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">
                                  Verificação de autenticidade
                               </a>
                         </div>
                    </div>
                    <div class="col-12">
                        <div class="textoCardServicos mt-4">
                             <a onclick="window.scrollTo({ top: 0, behavior: 'smooth' })">
                                 Permite que a certidão digital e o instrumento de protesto expedidos eletronicamente possam ter sua autenticidade verificada de maneira segura
                             </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="imgNossoServicos">
                            <a href="../pdf/ManualdeProtesto.pdf" target="_blank" style="text-decoration: none; color: inherit;">
                                 <img src="~@/assets/imgs/nossos_servicos/verificacao-autenticidade.svg"   class="w-50"/>
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="tituloCardServicos mt-4">
                            <a href="../pdf/ManualdeProtesto.pdf" target="_blank" style="text-decoration: none; color: inherit;">
                                Pedido de Protesto
                            </a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="textoCardServicos mt-4">
                             <a href="../pdf/ManualdeProtesto.pdf" target="_blank" style="text-decoration: none; color: inherit;">
                                Permite enviar títulos a protesto eletrônicamente para todos os cartorios do país, por meio do uso do Certificado Digital ICP-Brasil.
                             </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row ml-4">
            <div class="offset-xl-1 col-12 text-center">
                <div class="row ml-4">
                    
                </div>
            </div>
        </div>
        <div class="row ml-4">
            <div class="offset-xl-1 col-12 text-center">
                <div class="row ml-4">
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
#textoServico{
  margin-top: calc(8%);
}
.imgNossoServicos{
    margin-top: calc(40%);
}
.tituloCardServicos{
    color: #69A9Fc;
    font-weight: bold;
    font-size: 16;
}
.textoCardServicos{
    color: #084F84;
    font-size: 14px;
}
.textoNossosServicos
{
  color: #084f84;
  font-size: 29px;
  line-height: 25px;
  /* margin-right: 500px; */
  text-align: left;
  font-weight: bold;
}
@media (min-width: 900px) {
  .textoNossosServicos
  {
    color: #084f84;
    font-size: 35px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
  }
}
</style>